import { SkeletonLoader } from '@ui/common/components/SkeletonLoader/SkeletonLoader';
import { ArticleVariant } from '@repo/types';

type ArticleCardSkeletonProps = {
  variant?: ArticleVariant;
  showImage?: boolean;
  showTag?: boolean;
  showDate?: boolean;
  showAuthor?: boolean;
  showSummary?: boolean;
};

export function ArticleCardSkeleton({
  variant = ArticleVariant.Default,
  showImage = true,
  showTag = true,
  showDate = true,
  showAuthor = false,
  showSummary = false,
}: ArticleCardSkeletonProps) {
  const variantClass = {
    [ArticleVariant.Default]: 'article-card--default',
    [ArticleVariant.Stacked]: 'article-card--stacked',
    [ArticleVariant.TextSideBySide]: 'article-card--text-side-by-side',
  }[variant];

  return (
    <div className={`article-card article-card--skeleton ${variantClass}`}>
      <div className="article-card__link-wrapper">
        {showImage && (
          <div className="article-card__media-wrapper">
            <SkeletonLoader height="100%" containerClassName="article-card__skeleton-image" />
          </div>
        )}
        <div className="article-card__content">
          <div className="article-card__tag-date-wrapper">
            {showTag && <SkeletonLoader width={60} height={16} />}
            {showDate && <SkeletonLoader width={80} height={16} />}
          </div>
          <SkeletonLoader count={2} height={20} style={{ marginTop: 8 }} />
          {showAuthor && <SkeletonLoader width={100} height={14} style={{ marginTop: 8 }} />}
          {showSummary && <SkeletonLoader count={2} height={14} style={{ marginTop: 8 }} />}
        </div>
      </div>
    </div>
  );
}
